import styled, { css } from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { colorCoreGray500, colorCoreGray600 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export const ProductPartStyled = styled.div `
  display: flex;
  box-sizing: border-box;
  padding: 16px;
  border-bottom: 1px solid transparent;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'};

  &:not(:last-child) {
    border-color: ${colorCoreGray500};
  }
`;
export const ImageWrapper = styled(Link) `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: ${({ width }) => width};
  height: ${({ width }) => width};

  border: 1px solid ${colorCoreGray600};
`;
export const CardContainer = styled(FlexWrapper) `
  ${({ isImageShowed, isRightToLeft }) => isImageShowed &&
    css `
      ${isRightToLeft ? 'margin-right' : 'margin-left'}: 12px;
    `}
`;
